import { downloadBlobAsFile, generateXLSX, getCsvData, XLSXRow } from '@retail/products/utils';
import dayjs from 'dayjs';
import { ConditionsNew } from '@retail/calculus/types';
import { useAppTFunction } from '@retail/app/i18n';

const columnOrder = [
  'mgItemNumber',
  'groupNumber',
  'discountGroupCode',
  'validFrom',
  'percentAddon',
  'fixedAddon',
  'fixedAddonUnit',
];

const uploadFreightCsvData =
  '\uFEFFMgItem-nummer;Varugrupp;Rabattgrupp;GyldigFra;ProcentuelltTillägg;Frakttillägg;Krontillägg;Enhet';

export const useFreightExport = () => {
  const t = useAppTFunction();
  const data: XLSXRow[] = [[...uploadFreightCsvData.split(';')]];

  const getFreightAsRows = (freightConditions: ConditionsNew[]) => {
    const freightRows: XLSXRow[] = [];

    freightConditions.forEach((freight) => {
      const row: Record<string, string | number | null> = {
        mgItemNumber: freight.bindingType === 'MG_SUPPLIER_ITEM' ? freight.bindingTargetId : null,
        groupNumber:
          freight.bindingType === 'OVERGRUPPE' ||
          freight.bindingType === 'HOVEDGRUPPE' ||
          freight.bindingType === 'VAREGRUPPE'
            ? String(freight.bindingTargetId)
            : null,
        discountGroupCode:
          freight.bindingType === 'DISCOUNT_GROUP' ? String(freight.bindingTargetId) : null,
        validFrom: freight.freightCondition?.validFrom
          ? dayjs(freight.freightCondition.validFrom).format('YYYY-MM-DD')
          : null,
        percentAddon: freight.freightCondition?.percentAddon ?? null,
        fixedAddon: freight.freightCondition?.fixedAddOn ?? null,
        fixedAddonUnit: freight.freightCondition?.fixedAddOnUnit ?? null,
      };

      const rowValues = columnOrder.map((key) => row[key]);
      freightRows.push(rowValues);
    });

    return freightRows;
  };

  const exportAsCsv = (freightConditions: ConditionsNew[]) => {
    const updatedData = [...data, ...getFreightAsRows(freightConditions)];
    const csvData = getCsvData(updatedData);

    const blob = new Blob([csvData], {
      type: 'text/csv',
    });

    downloadBlobAsFile(
      blob,
      `${t('freight.freightConditions')}-${dayjs().format('YYYY-MM-DD')}.csv`
    );
  };

  const exportAsXLSX = async (freightConditions: ConditionsNew[]) => {
    const updatedData = [...data, ...getFreightAsRows(freightConditions)];

    try {
      generateXLSX({
        rows: updatedData,
        fileName: `${t('freight.freightConditions')}-${dayjs().format('YYYY-MM-DD')}`,
      });
    } catch (error) {
      console.error('Error exporting XLSX:', error);
    }
  };

  return {
    exportAsCsv,
    exportAsXLSX,
  };
};
